import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import LoadingIcon from "mdi-react/LoadingIcon";

import { propertyConstants } from "../../constants";
import PropertyCard from "../../shared/components/property-card/PropertyCard";
import { propertyActions } from "../../redux/actions";

const { ALL_RECOMMENDED_PROPERTY_BUTTON } = propertyConstants;

const RecommendedProperty = (props) => {
  const {
    amenities,
    allRecommendedProperty,
    getAllRecommendedProperty,
    spinnerActions,
    filters,
    allAllowedCountries,
    userPropertyTypes,
    allPropertyTypes,
    isAuthenticated,
    totalRecommendedProperties,
    getAllFavouritesProperty,
    getPropertyTypesByUser,
  } = props;

  const availablePropertyTypes =
    !isAuthenticated && userPropertyTypes.length === 0
      ? allPropertyTypes
      : userPropertyTypes;

  const [properties, setProperties] = useState([]);
  const [payload, setPayload] = useState({
    pageSize: 12,
    pageNumber: 0,
    countryIds:
      filters.countryIds.length > 0
        ? filters.countryIds
        : allAllowedCountries.map((country) => country.id),
    propertyTypeIds:
      filters.propertyTypeIds.length > 0
        ? filters.propertyTypeIds
        : availablePropertyTypes.map((pType) => pType.id),
    amenityIds: amenities,
  });

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  useEffect(() => {
    const canFetchAuthenticated =
      isAuthenticated &&
      allAllowedCountries.length > 0 &&
      userPropertyTypes.length > 0;
    const canFetchGuest =
      !isAuthenticated &&
      (userPropertyTypes.length > 0 || allPropertyTypes.length > 0);

    if (canFetchAuthenticated || canFetchGuest) {
      getAllRecommendedProperty(payload);
    }
    // eslint-disable-next-line
  }, [payload]);

  useEffect(() => {
    if (allRecommendedProperty) {
      setProperties(allRecommendedProperty);
    }
  }, [allRecommendedProperty]);

  useEffect(() => {
    setPayload({
      pageSize: 12,
      pageNumber: 0,
      countryIds: isAuthenticated
        ? filters.countryIds.length > 0
          ? filters.countryIds
          : allAllowedCountries.map((country) => country.id)
        : filters.countryIds,
      propertyTypeIds:
        filters.propertyTypeIds.length > 0
          ? filters.propertyTypeIds
          : availablePropertyTypes.map((pType) => pType.id),
      amenityIds: amenities,
    });
    // eslint-disable-next-line
  }, [
    allAllowedCountries,
    userPropertyTypes,
    allPropertyTypes,
    filters,
    amenities,
    isAuthenticated,
  ]);

  return (
    <div className="recommended-property container">
      <div className="recommended-listing">
        <div className="d-flex align-items-center gap-2">
          <h2 className="fs-1-75 fw-bold">Recommended Listing</h2>
          {spinner(propertyConstants.ALL_RECOMMENDED_PROPERTY) > -1 && (
            <div className="spinner-heading">
              <LoadingIcon />
            </div>
          )}
        </div>
      </div>
      <div className="row mt-3 pt-2">
        {properties.map((property) => (
          <React.Fragment key={property?.id}>
            <PropertyCard
              property={property}
              refetch={(isRemoved) => {
                getAllRecommendedProperty(payload, false);
                if (isAuthenticated) {
                  const { amenityIds, pageNumber, ...rest } = payload;
                  getAllFavouritesProperty({
                    ...rest,
                    pageSize: 4,
                  });
                  if (isRemoved) {
                    getPropertyTypesByUser({
                      countryIds: payload.countryIds,
                    });
                  }
                }
              }}
            />
          </React.Fragment>
        ))}
        {properties.length === 0 && (
          <div className="text-center fs-5">No Properties Found!</div>
        )}
      </div>
      {totalRecommendedProperties > allRecommendedProperty.length && (
        <div className="see-more-button">
          <button
            onClick={() =>
              setPayload((prev) => ({
                ...prev,
                pageNumber: prev.pageNumber + 1,
              }))
            }
            disabled={spinner(ALL_RECOMMENDED_PROPERTY_BUTTON) > -1}
          >
            {spinner(ALL_RECOMMENDED_PROPERTY_BUTTON) > -1
              ? "Loading..."
              : "See More"}
          </button>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  spinnerActions: state.systemReducer.spinnerActions,
  allAllowedCountries: state.homeReducer.allAllowedCountries,
  userPropertyTypes: state.propertyReducer.userPropertyTypes,
  allPropertyTypes: state.propertyReducer.allPropertyTypes,
  isAuthenticated: state.authReducer.isAuthenticated,
  allRecommendedProperty: state.propertyReducer.allRecommendedProperty,
  totalRecommendedProperties: state.propertyReducer.totalRecommendedProperties,
});

const mapDispatchToProps = (dispatch) => ({
  getAllRecommendedProperty: (data) =>
    dispatch(propertyActions.getAllRecommendedProperty(data)),
  getAllFavouritesProperty: (data) =>
    dispatch(propertyActions.getAllFavouritesProperty(data)),
  getPropertyTypesByUser: (data) =>
    dispatch(propertyActions.getPropertyTypesByUser(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecommendedProperty);
